var render, staticRenderFns
import script from "./addSqlDataModal.vue?vue&type=script&lang=js"
export * from "./addSqlDataModal.vue?vue&type=script&lang=js"
import style0 from "./addSqlDataModal.vue?vue&type=style&index=0&id=126e402a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e402a",
  null
  
)

export default component.exports